// import {Column,Line} from '@ant-design/charts';
import { Col, message, Modal, Row, Space, Spin, Table } from "antd";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import AxiosService from "../services/APIService";
import totalBalIcon1 from "../Assets/total_balance_i1.svg";
import totalBalIcon2 from "../Assets/total_balance_i2.svg";
import serverIcon2 from "../Assets/total_botcharge.svg";
import totalDepositIcon from "../Assets/total_deposite_balance.svg";
import { LocalStorageService } from "../services/LocalStorage";
import setupInstructionPDF from "../Assets/botSetupInstruction.pdf";
import { HiOutlineDocumentDownload } from "react-icons/hi";
import { FiDownload } from "react-icons/fi";
import { downloadDocument } from "../services/aws";

function UserDashboard() {
  const apiService = new AxiosService();
  const [profitData, setProfitData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get("token");

    if (urlToken) {
      LocalStorageService.setItem("userToken", urlToken);
      apiService
        .get("/auth/me")
        .then((response) => {
          if (response) {
            LocalStorageService.setItem("user", response);
            fetchDashboardData(response);
          }
        })
        .catch((error) => {
          console.error("Error fetching user data:", error);
          if (error.response?.status === 401) {
            LocalStorageService.removeItem("userToken");
            LocalStorageService.removeItem("user");
            window.location.href = "/login";
          }
        });
      window.history.replaceState({}, document.title, window.location.pathname);
    } else {
      const userData = LocalStorageService.getItem("user");
      if (userData) {
        fetchDashboardData(userData);
      }
    }
  }, []);

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const uploadedDates = profitData?.uploadedFiles?.map((file) => new Date(file.uploadedAt)) || [];
  const earliestUploadDate = uploadedDates.length ? new Date(Math.min(...uploadedDates)) : new Date();

  const completionDate = new Date(earliestUploadDate);
  completionDate.setFullYear(completionDate.getFullYear() + 1);

  function getDaysRemaining(endDate) {
    const currentDate = new Date();
    const timeDifference = endDate - currentDate;
    return Math?.ceil(timeDifference / (1000 * 60 * 60 * 24));
  }

  const daysRemaining = getDaysRemaining(completionDate);

  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const fetchDashboardData = (userData) => {
    setLoading(true);
    const user = userData || LocalStorageService.getItem("user");
    if (!user || !user._id) {
      message.error("User data not found");
      setLoading(false);
      return;
    }

    apiService
      .get(`/auth/user-dashboard/${user._id}`)
      .then((res) => {
        setProfitData(res);
      })
      .catch((e) => {
        message.error(e.message || "Something went wrong");
        if (e.response?.status === 401) {
          LocalStorageService.removeItem("userToken");
          LocalStorageService.removeItem("user");
          window.location.href = "/login";
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const downloadFile = (fileData) => {
    const { presignedUrl, fileName } = fileData || {};

    if (presignedUrl) {
      fetch(presignedUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          console.error("Download failed:", err);
          message.error("Failed to download file");
        });
    } else {
      message.error("Download URL not found");
    }
  };

  const downloadSetupInstruction = () => {
    const anchor = document.createElement("a");
    anchor.href = setupInstructionPDF;
    anchor.download = "Pip_Grid_Bot_Setup_Instruction.pdf";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const columns = [
    {
      title: "File Name",
      dataIndex: "fileName",
      key: "fileName",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Action",
      key: "action",
      render: (record) => {
        return (
          <Space size="middle">
            <a onClick={() => downloadFile(record)}>Download</a>
          </Space>
        );
      },
    },
  ];

  return (
    <>
      <Spin spinning={loading} size="large">
        <Row gutter={[20, 20]}>
          <Col span={24}>
            <Row gutter={[20, 20]}>
              <Col span={8}>
                <div
                  className="dashboard-block"
                  style={{
                    backgroundColor: "#E674E4",
                    padding: "20px",
                    minHeight: "240px",
                    color: "#54189D",
                  }}
                >
                  <h3>
                    Remaining days
                  </h3>
                  <div style={{ maxHeight: "180px", overflowY: "auto" }} className="custom-scrollbar">
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead>
                        <tr>
                          <th style={{ textAlign: "left", padding: "2px 0", fontSize: "12px" }}>Plan</th>
                          <th style={{ textAlign: "right", padding: "2px 0", fontSize: "12px" }}>Days</th>
                        </tr>
                      </thead>
                      <tbody>
                        {profitData?.uploadedFiles?.map((file, index) => {
                          const uploadDate = new Date(file.uploadedAt);
                          const completionDate = new Date(uploadDate);
                          completionDate.setFullYear(completionDate.getFullYear() + 1);
                          const days = getDaysRemaining(completionDate);
                          return (
                            <tr key={index} style={{ borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
                              <td style={{ padding: "2px 0", fontSize: "10px", fontWeight: "500" }}>
                                {file.planName || "N/A"}
                              </td>
                              <td style={{ padding: "2px 0", textAlign: "right", fontSize: "10px", fontWeight: "bold" }}>
                                {days > 0 ? days : 0}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
              <Col span={8} onClick={() => setIsModalOpen(true)} style={{ cursor: "pointer" }}>
                <div
                  className="dashboard-block"
                  style={{ backgroundColor: "#A05AF4", padding: "50px 10px 50px 100px" }}
                >
                  <h3>{profitData?.uploadedFiles.length}</h3>
                  <span>Files List (Download File)</span>
                  <span style={{ fontSize: 15, fontWeight: 300, display: "flex", alignItems: "center", gap: "5px" }}>
                    <FiDownload /> Click here to download file
                  </span>
                  <img src={totalDepositIcon} style={{ width: "51px", top: 11, left: 11 }} className="position" />
                  <img src={totalDepositIcon} style={{ width: "51px", bottom: 11, right: 11 }} className="position" />
                </div>
              </Col>
              <Col span={8}>
                <div className="dashboard-block" style={{ backgroundColor: "#17C9F7", padding: "86px 10px 86px 50px" }}>
                  {/* <h3>{moment(customer?.account_created_date ? customer?.account_created_date : customer?.created_at).fromNow(true)}</h3> */}
                  <span
                    style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}
                    onClick={downloadSetupInstruction}
                  >
                    Set-up Instruction <HiOutlineDocumentDownload />
                  </span>
                  <img src={totalBalIcon1} style={{ width: "70px", top: 24, left: 24 }} className="position" />
                  <img src={totalBalIcon2} style={{ width: "147px", bottom: 18, right: 25 }} className="position" />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Spin>

      <Modal title="File List" open={isModalOpen} onCancel={handleCancel} footer={[]} width={800}>
        <Table columns={columns} dataSource={profitData?.uploadedFiles} pagination={false} />
      </Modal>
    </>
  );
}

const mapStateToProps = ({ login }) => {
  const { user } = login;
  return { user };
};

export default connect(mapStateToProps, {})(UserDashboard);
